import React, { useState, useEffect } from "react";

const Countdown = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = null;
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      const updatedTimeLeft = calculateTimeLeft();
      setTimeLeft(updatedTimeLeft);

      if (!updatedTimeLeft) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetDate]);

  if (!timeLeft) {
    return <div>The event has started!</div>;
  }

  return (
    <div className="flex justify-center items-center gap-5 py-5">
      <div className="flex flex-col justify-center items-center ">
        <div className="border-2 border-white rounded-full h-18 w-18 flex justify-center items-center">
          <p className="p-5 text-2xl text-white font-semibold">
            {timeLeft.days}
          </p>
        </div>
        <p className="text-base mt-2 text-black">DAYS</p>
      </div>
      <div className="flex flex-col justify-center items-center ">
        <div className="border-2 border-white rounded-full h-18 w-18 flex justify-center items-center">
          <p className="p-5 text-2xl text-white font-semibold">
            {timeLeft.hours}
          </p>
        </div>
        <p className="text-base mt-2 text-black">HRS</p>
      </div>
      <div className="flex flex-col justify-center items-center ">
        <div className="border-2 border-white rounded-full h-18 w-18 flex justify-center items-center">
          <p className="p-5 text-2xl text-white font-semibold">
            {timeLeft.minutes}
          </p>
        </div>
        <p className="text-base mt-2 text-black">MINS</p>
      </div>
      <div className="flex flex-col justify-center items-center ">
        <div className="border-2 border-white rounded-full h-18 w-18 flex justify-center items-center">
          <p className="p-5 text-2xl text-white font-semibold">
            {timeLeft.seconds}
          </p>
        </div>
        <p className="text-base mt-2 text-black">SECS</p>
      </div>
    </div>
  );
};

export default Countdown;
